import React, { Component } from 'react';
import logo from '../assets/survive-the-night.png';

import buttonBuy from '../assets/button-buy.png';
import howToPlay from '../assets/how-to-play.png';

import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import website from '../assets/website.png';
import kofi from '../assets/kofi.png';

import playTheGame from '../assets/play-the-game.png';
import candleYellow from '../assets/candle-yellow.gif';

import badWordSource from '../../BadWords/bad-words.txt'

import '../styles/Vote.css';

export class ShowNotStarted extends Component {
    render() {
        const webPaLink = "https://www.undisposables.co.uk/";
        const facebLink = "https://www.facebook.com/undisposables/";
        const instaLink = "https://www.instagram.com/the_undisposables/";
        const kofiiLink = "https://ko-fi.com/the_undisposables";


        return (
            <div class="start-page page-content">
                <div>
                    <img class="stnLogo" src={logo} alt="Survive The Night" />
                    <h2 class="subtitle">The game <br />has not yet <br />begun...</h2>
                </div>
                <div class="homeActions">
                    <a href="https://weareoldred.co.uk/whats-on/grimfest/survive-the-night/" class="home-btn-link">
                        <img src={buttonBuy} class="home-btn-img" alt="Buy Tickets" />
                    </a>
                    <a href="https://www.undisposables.co.uk/how-to-play" class="home-btn-link">
                        <img src={howToPlay} class="home-btn-img" alt="How to Play" />
                    </a>
                </div>
                <div class="logos">
                    <a class="home-logo-link" href={webPaLink}> <img class="home-logo-img" src={website}   alt="website" /> </a>
                    <a class="home-logo-link" href={facebLink}> <img class="home-logo-img" src={facebook}  alt="facebook" /> </a>
                    <a class="home-logo-link" href={instaLink}> <img class="home-logo-img" src={instagram} alt="instagram" /> </a>
                    <a class="home-logo-link" href={kofiiLink}> <img class="home-logo-img" src={kofi}      alt="kofi" /> </a>
                </div>
            </div>
        )
    }
}
export class SetName extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            badName: false,
            badWordList: [""]
        };
        this.updateName = this.updateName.bind(this);
        this.submitName = this.submitName.bind(this);
        this.setBadWordList = this.setBadWordList.bind(this);
    }

    componentDidMount() {
        fetch(badWordSource)
            .then(response => response.text())
            .then(response => {
                console.log("readList");
                this.setBadWordList(response);
            });
    }

    setBadWordList(badWords) {
        this.setState({ badWordList: badWords.split('\r\n') });
    }

    updateName(nameEnteredBox) {
        const name_entered = nameEnteredBox.target.value;
        this.setState({ name: name_entered });
    }

    checkforBadWord(badWords, name) {
        for (var i = 0; i < badWords.length; i++) {
            if (name.includes(badWords[i])) {
                console.log(badWords[i])
                return true;
            }
        }
    }

    submitName() {
        if (this.state.name !== "") {
            let lowerName = this.state.name.toLowerCase();

            let isBadWords = this.checkforBadWord(this.state.badWordList, lowerName);
            
            if (isBadWords) {
                this.setState({ badName: true });
            } else {
                this.props.handler(this.state.name.replace(/|/g, ''));
            }           
        }
    }

    render() {
        let badLanguageWarning = '';
        if (this.state.badName) { badLanguageWarning = <h2 class="subtitle">Mind Your Language!</h2> }
        return (
            <div class="name-page page-content">
                <div class="name-page-content">
                    <img src={logo} class="stnLogo" alt="Survive The Night" />
                    <h2 class="subtitle">Player Name: </h2>
                    {badLanguageWarning}
                    <input type="text" id="name" onChange={this.updateName} />
                    <div class="row">
                        <img class="btn-playTheGame" src={playTheGame} onClick={this.submitName} alt="Click to play" />
                    </div>
                    <img class="candle" src={candleYellow} alt="flickering yellow candle" />
                </div>
           </div>
        )
    }
}

export class NoVote extends Component {
    render() {
        return (
            <div class="page-content">
                <div class="keep-me-close-page">
                    <img src={logo} class="stnLogo" alt="Survive The Night" />
                    <h1 class="keep-me-close">Keep me close <br />{this.props.userName}</h1>
                </div>
                <img class="candle" src={candleYellow} alt="flickering yellow candle" />
            </div>
        )
    }
}